import { render, staticRenderFns } from "./DeletableChips.vue?vue&type=template&id=4e0b0f22&"
import script from "./DeletableChips.vue?vue&type=script&lang=ts&"
export * from "./DeletableChips.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports